// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { AlertComponentProps } from 'react-alert'
import { FormattedMessage } from 'react-intl';

import S from './styles';

interface SnackbarProps extends AlertComponentProps {
  containerStyle?: React.CSSProperties;
}

const VideoSnackbarTemplate = ({ options, message, containerStyle, close }: SnackbarProps):JSX.Element => {
  return (
    <S.SnackbarBubble style={containerStyle}>
      <S.SnackbarMessage><FormattedMessage id="F003"/></S.SnackbarMessage>
      <S.SnackbarControlContainer onClick={close}>
        {message}
        <S.SnackbarDecline onClick={close}/>
      </S.SnackbarControlContainer>
    </S.SnackbarBubble>
  )
}

export { VideoSnackbarTemplate as default };
